import { render, staticRenderFns } from "./PphSupplier.vue?vue&type=template&id=6df04f40&"
import script from "./PphSupplier.vue?vue&type=script&lang=ts&"
export * from "./PphSupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df04f40')) {
      api.createRecord('6df04f40', component.options)
    } else {
      api.reload('6df04f40', component.options)
    }
    module.hot.accept("./PphSupplier.vue?vue&type=template&id=6df04f40&", function () {
      api.rerender('6df04f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/reports/PphSupplier.vue"
export default component.exports